import { Component, Inject, Input, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Data } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { BudgetDetailDetailService } from '../../../service/budget-detail.service';
import { BudgetService } from '../../../service/budget.service';
import { NzTreeSelectComponent } from 'ng-zorro-antd/tree-select';
import { CostService } from '../../../service/cost.service';
import { formatNumber } from '@angular/common';


@Component({
  selector: 'app-budget-detail-budget',
  templateUrl: './budget-detail-budget.component.html',
  styleUrls: ['./budget-detail-budget.component.less']
})
export class BudgetDetailBudgetComponent implements OnInit {

  @ViewChild('costTypeTreeSelect') costTypeTreeSelect: NzTreeSelectComponent;
  // 预算bid
  @Input() bid: any;
  @Input() detailMonth: any;
  // 在budget存储明细，用于服务端的数据更新
  budget: any;
  validateForm: FormGroup;
  // 费用类型
  typeMap = new Map<number, any>();
  // cost_type
  costTypes = [];

  // 右侧表格
  RightElementIdSet = new Set<number>();
  leftList = [];
  isIndeterminateRight: boolean;
  listOfData = [];
  RightTotal: number;
  RightPageSize: number;
  RightPageIndex: number;
  RightFlag = false;
  LeftTotal: number;
  RightstartRow: number;

  // 左侧表格
  LeftElementIdSet = new Set<number>();
  LeftList = [];
  LeftFlag = false;
  isIndeterminateLeft: boolean;
  formatter = (value: number): string => {
    return formatNumber(value, this.localeId, '1.2-2');
  }

  constructor(
    private fb: FormBuilder,
    public message: NzMessageService,
    private modal: NzModalService,
    private modalRef: NzModalRef,
    private budgetDetailDetailService: BudgetDetailDetailService,
    private budgetService: BudgetService,
    private costService: CostService,
    @Inject(LOCALE_ID) private localeId: string
  ) {
    this.RightstartRow = 1;
    this.RightPageIndex = 1;
    this.RightPageSize = 10;
  }

  async ngOnInit(): Promise<void> {
    // 构建响应式表单
    this.validateForm = this.fb.group({ costTypeId: null, bdName: null });
    // 初始化左右表格的数据
    this.queryLeftData(this.bid);
    this.queryRightData(1);
    // 填充下拉框
    const types = await this.costService.getCostTypeList();
    this.costTypes = this.initCostTypeTree(types);
  }

  LeftItemChecked(id: number, checked: boolean): void {
    // 维护LeftElementIdSet
    this.leftUpdateElementIdSet(id, checked);
    // 更新表格选中状态
    this.leftRefreshCheckedStatus();
  }
  // 调用：更新当前页记录的选择状态
  leftRefreshCheckedStatus(): void {
    // 当前页记录是否全选
    if (this.leftList.length === 0) {
      // 如果listOfCurrentPageDataRight大小为0，那调用erery方法默认返回true，需要手动修改checkedRight的值
      this.LeftFlag = false;
    }
    else {
      this.LeftFlag = this.leftList.every(item => {
        return this.LeftElementIdSet.has(item.bdid);
      });
    }
    // 当前页是否有记录被选中
    this.isIndeterminateRight = this.leftList.some(item => {
      return this.LeftElementIdSet.has(item.bdid) && !this.LeftFlag;
    });
  }
  // 更新被选中记录id的集合
  leftUpdateElementIdSet(id: number, checked: boolean): void {
    if (checked) {
      this.LeftElementIdSet.add(id);
    } else {
      this.LeftElementIdSet.delete(id);
    }
  }
  // 点击全选按钮时触发
  LeftCheckAll(value: boolean): void {
    this.leftList.forEach(item => this.leftUpdateElementIdSet(item.bdid, value));
    this.leftRefreshCheckedStatus();
  }
  queryLeftData(bid: number) {
    // detailMonth 月度预算
    if (this.detailMonth !== undefined && this.detailMonth !== null) {
      this.LeftList = this.detailMonth.detailMonths;
      this.LeftTotal = this.LeftList.length;
    } else {
      this.budgetService.getBudgetWithPrice(bid).then((value) => {
        // 保存根据bid查询出来的预算
        this.budget = value;
        // 取明细数组填充到表单的[nzData]属性
        this.LeftList = this.budget.budgetDetails;
        this.LeftTotal = this.LeftList.length;
      });
    }
  }
  // 触发（当前页数据改变）：获取当前页数据、更新选择状态
  LeftPageDataChange(CurrentPageData: Data[]): void {
    this.leftList = CurrentPageData;
    // tslint:disable-next-line:no-unused-expression
    this.leftList;
    this.leftRefreshCheckedStatus();
  }

  // ===========================================================================左侧表格相关方法

  RightItemChecked(id: number, checked: boolean): void {
    this.updateRightElementIdSet(id, checked);
    this.RightRefreshCheckedStatus();
  }
  RightRefreshCheckedStatus(): void {
    // 当前页记录是否全选
    if (this.leftList.length === 0) {
      // 如果listOfCurrentPageDataRight大小为0，那调用erery方法默认返回true，需要手动修改checkedRight的值
      this.LeftFlag = false;
    } else {
      this.RightFlag = this.listOfData.every(item => {
        return this.RightElementIdSet.has(item.bdid);
      });
    }
    // 当前页是否有记录被选中
    // this.isIndeterminateRight = this.leftList.some(item => this.LeftElementIdSet.has(item.id)) && !this.LeftFlag;
    this.isIndeterminateRight = this.listOfData.some(item => {
      return this.RightElementIdSet.has(item.bdid) && !this.RightFlag;
    });
  }
  updateRightElementIdSet(id: number, checked: boolean): void {
    if (checked) {
      this.RightElementIdSet.add(id);
    } else {
      this.RightElementIdSet.delete(id);
    }
  }
  RightCheckAll(value: boolean): void {
    this.listOfData.forEach((item) => {
      this.updateRightElementIdSet(item.bdid, value);
    });
    this.RightRefreshCheckedStatus();
  }
  // nzPageIndexChange页码改变事件
  RightPageIndexChange(pageIndex): void {
    this.RightPageIndex = pageIndex;
    this.queryRightData(0);
    // 换页时刷新
    this.RightRefreshCheckedStatus();
  }
  RightPageDataChange($event: []): void {
    this.listOfData = $event;
    this.RightRefreshCheckedStatus();
  }
  queryRightData(flag: number) {
    if (flag === 1) {
      this.RightPageIndex = 1;
      this.RightPageSize = 10;
    }
    // tslint:disable-next-line:max-line-length
    this.budgetDetailDetailService.getBudgetDetailListByCondition(this.validateForm.value, this.RightPageIndex, this.RightPageSize).then((value) => {
      // 取出pageinfo中的list属性,填充到table组件的nzData属性中
      this.listOfData = value.list;
      this.RightTotal = value.total;
      this.RightstartRow = value.startRow;
    });
  }


  // 只是决定归属关系，那就只更新关联表，而不去跟新预算和明细表
  deleteRows(): void {
    if (this.budget !== undefined && this.budget !== null) {

      if (this.LeftFlag === true) {
        this.budget.budgetDetails = [];
      } else {
        const array: any[] = this.budget.budgetDetails;
        for (let i = 0; i < array.length; i++) {
          const flag = this.LeftElementIdSet.has(array[i].bdid);
          if (flag === true) {
            this.budget.budgetDetails.splice(i, 1);
          }
        }
      }
    }

    if (this.detailMonth !== undefined && this.detailMonth !== null) {

      if (this.LeftFlag === true) {
        this.detailMonth.detailMonths = [];
      } else {
        const array: any[] = this.detailMonth.detailMonths;
        for (let i = 0; i < array.length; i++) {
          const flag = this.LeftElementIdSet.has(array[i].bdid);
          if (flag === true) {
            this.detailMonth.detailMonths.splice(i, 1);
          }
        }
      }
    }

    this.refreshListDataRight();
  }


  refreshListDataRight() {
    if (this.detailMonth !== undefined && this.detailMonth !== null) {
      const detailMonth = JSON.parse(JSON.stringify(this.detailMonth));
      this.LeftList = detailMonth.detailMonths;
      this.LeftTotal = this.LeftList.length;
    } else {
      // 刷新页面，注意用新的内存地址来让angular检测到
      const newBudget = JSON.parse(JSON.stringify(this.budget));
      this.LeftList = newBudget.budgetDetails;
      this.LeftTotal = newBudget.budgetDetails.length;
    }

  }

  // 从后端查询到预算，然后对预算的明细数组属性进行操作，最后把budget发送到后端进行更新
  // this.budget就是唯一需要被操作的对象
  addRows() {
    this.twice();
    // 刷新右侧数据（注意：数据来源不是直接从服务器请求了）
    this.refreshListDataRight();
  }

  twice() {
    // bdids（该预算下所有明细的id集合）
    const bdids = new Set<number>();
    this.LeftList.forEach((detail: any) => {
      bdids.add(detail.bdid);
    });
    this.listOfData.forEach(budgetDetail => {
      if (this.RightElementIdSet.has(budgetDetail.bdid) && !bdids.has(budgetDetail.bdid)) {
        bdids.add(budgetDetail.bdid);
        // 给明细的actualValue属性默认赋值0
        budgetDetail.actualValue = 0;
        if (this.detailMonth !== undefined && this.detailMonth !== null) {
          this.detailMonth.detailMonths.push(budgetDetail);
        } else {
          this.budget.budgetDetails.push(budgetDetail);
        }

      }
    });

  }

  submitUpdate() {
    if (this.bid !== undefined && this.bid !== null) {
      this.budget.bid = this.bid;
      this.budget.budgetDetails = this.LeftList;
      this.budgetService.updateBudgetDetails(this.budget).then((value) => {
        if (value.code === 200) {
          // 请求后端，刷新右侧记录
          this.queryLeftData(this.bid);
          this.modal.success({
            nzTitle: '预算管理',
            nzContent: `更新预算完成！`
          });
          this.modalRef.destroy();
        } else {
          this.modal.error({
            nzTitle: '预算管理',
            nzContent: `更新预算失败！`
          });
        }
      });
    } else {
      this.detailMonth.detailMonths = this.LeftList;
      this.budgetService.updateBudgetMonth(this.detailMonth).then((result: any) => {
        // if (result.code === 200) {
        //   // 请求后端，刷新右侧记录
        //   this.nzMessageService.info('保存成功');
        //   this.queryLeftData(this.bid);
        // } else {
        //   this.nzMessageService.error('保存失败');
        // }
        if (result.code === 200) {
          // 请求后端，刷新右侧记录
          this.queryLeftData(this.bid);
          this.modal.success({
            nzTitle: '月度预算管理',
            nzContent: `更新预算完成！`
          });
          this.modalRef.destroy();
        } else {
          this.modal.error({
            nzTitle: '月度预算管理',
            nzContent: `更新预算失败！`
          });
        }

      });
    }

  }
  // NzModalRef服务形式的对话框组件
  cancelUpdate() {
    this.modalRef.destroy();
  }
  // 分页查询明细
  submitForm() {
    this.queryRightData(1);
  }
  resetForm() {
    // 清空表单内容，重新查询
    this.validateForm.reset();
    this.queryRightData(1);
  }
  initCostTypeTree(types: any[]) {
    const costTypes = [];
    for (const type of types) {
      const node = {
        title: type.typeName,
        value: type.typeId,
        key: type.typeId,
        isLeaf: true
      };
      if (type.parentId === 0) {
        costTypes.push(node);
      } else {
        const parent = this.typeMap.get(type.parentId);
        if (parent != null) {
          if (parent.children == null) {
            parent.children = [];
            parent.isLeaf = false;
          }
          parent.children.push(node);
        }
      }
      this.typeMap.set(type.typeId, node);
    }
    return costTypes;
  }
  valueChanged(item) {
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
